// extracted by mini-css-extract-plugin
export default {"autoComplete":"C5-z","error":"D5-z","disabled":"E5-z"};